module.exports = __webpack_public_path__ + "static/img/googleplay.14ed787.png";


//////////////////
// WEBPACK FOOTER
// ./src/RF_assets/icons/googleplay.png
// module id = ZEE5
// module chunks = 28